import React from "react";
import swal from 'sweetalert';
import history from "../auth/history";

class TokenErrorHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: ''



        }
    }

    tokenErrorHandle(msg,callBackUrl) {
   
        swal({
            title: "Sorry!",
            text: 'Authentication Error! Please Click to re-login',
            icon: "error",
            button: true,
            dangerMode: true,
        })
            .then(() => {
                history.push('/');
                history.go();

            });


    }

}
export default new TokenErrorHandler();
// const mapStateToProps = (
//     { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
//         miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId } }
// ) => ({
//     errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, clientRole, clientRequesterId
// });

// export default connect(mapStateToProps, null)(TALoad);
